<template>
  <div
    id="mobile-search-buttons"
    class="visible-xs visible-im"
  >
    <div
      v-show="mapButtonVisible"
      id="buttons-results"
    >
      <button
        type="button"
        class="btn btn-sm js-show-map"
        @click="showMap()"
      >
        Map
      </button>
    </div>
    <div
      v-show="mobileView === 'filters'"
      id="buttons-filters"
    >
      <button
        id="js-show-rooms"
        type="button"
        class="btn btn-sm js-show-results"
        @click="showResults()"
      >
        Show rooms ({{ totalRooms }})
      </button>
    </div>
    <div
      v-show="mobileView === 'map'"
      id="buttons-map"
    >
      <button
        type="button"
        class="btn btn-sm js-show-results"
        @click="showResults()"
      >
        List
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'MobileControls',
  computed: {
    ...mapState([
      'mobileView',
      'totalRooms',
      'toggle',
    ]),
    ...mapGetters([
    ]),
    mapButtonVisible() {
      if (this.mobileView !== 'results') {
        return false;
      }
      return true;
    },
  },
  methods: {
    showResults() {
      this.$store.dispatch('showResults');
    },
    showMap() {
      this.$store.dispatch('showMap');
    },
  },
};
</script>
